import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HistoricoInterface } from '../interface/HistoricoInterface';
import { CompaniaRastreadorInterface } from '../interface/CompaniaRastreadorInterface';
import { number } from 'echarts';
import { ListaVariacionInterface } from '../interface/ListaVariacionInterface';
import { ListaResultadosInterfase } from '../interface/ListaResultadosInterfase';
import { SseService } from './SseService';

export interface InterfaceformdataRastreador{
    condicionStr: string,
    diasEvaluar: number,
    fechaInicioString: string,
    rangoPorcentualEvaluar: number,
    diadesemana: boolean,
    diaSemanaSeleccionado: number | null,
    porcentaje : number,
    porcentajeNegativo: number,
    fechaFinString: string,//obviar
    idMercado : number,//8
    idNectum: number,
    idMercadoSerie: number,//8
    idNectumSerie: number,
    diashabiles: boolean,
    volatilidad: boolean,
    menorQueVIX:number,
    mayorQueVIX:number
    fechaInicio: string,
    periodoModeloPeriodico : number,
    stoplossCheck : boolean,
    stoplossDinamicCheck : boolean,
    profitCheck : boolean,
    period: number,
}
@Injectable({
    providedIn: 'root',
})
export class RastreadorService {
    constructor(private _sseService: SseService) {}

    //idMercado que debe ser un observable y enviar los cambios a los componentes que lo necesiten
    public idMercado = new BehaviorSubject<number>(8);
    public condiciones: string[] = [];
    public formdata = new BehaviorSubject <any>({
        condicionStr: '',
        diasEvaluar: 7,
        fechaInicioString: '2018-01-01',//'2020-01-0
        rangoPorcentualEvaluar: 5,
        diadesemana: true,
        diaSemanaSeleccionado: null,
        porcentaje : 20,
        porcentajeNegativo: 6,
        fechaFinString: '',//obviar
        idMercado : 8,//8
        idNectum: 1000,
        idMercadoSerie: 0,//8
        idNectumSerie: 0,
        diashabiles: false,
        volatilidad: false,
        menorQueVIX: 85,
        mayorQueVIX: 5    
    });

    public historicoVolatividad = new BehaviorSubject<HistoricoInterface[]>([]);
    public companiasRastreador = new BehaviorSubject<CompaniaRastreadorInterface[]>([]);
    public listaVariacion = new BehaviorSubject<ListaVariacionInterface[]>([]);
    public listaResultados = new BehaviorSubject<ListaResultadosInterfase[]>([]);
    public listaVariacionNegativa = new BehaviorSubject<ListaVariacionInterface[]>([]);
    public companiaVolatividad = new BehaviorSubject<HistoricoInterface[]>([]);
    public idNectumSeries = new BehaviorSubject<number>(0);
    private companiaSeleccionada = new BehaviorSubject<CompaniaRastreadorInterface>({
        idCompaniaLista: 0,
        nombre: '',
        descripcion: '',
        mercado: '',
        idMercado: 0,
        idNectum: 0,
        tipo: '',
        n: 0,
        fecha: '',
        proximo: '',
        dias: 0,
        timeProximo: '',
        timeActual: '',
        estado: false
    });
    private loadVolatil = new BehaviorSubject<boolean>(false);
    private loadCompania = new BehaviorSubject<boolean>(false);
    private loadVolatilCompania = new BehaviorSubject<boolean>(false);
    public companiaAnalisis = new BehaviorSubject<any>([]);
    public dataEarning = new BehaviorSubject<any>([]);
    /** id de la corrida de análisis persistida en tbl_analisis (evento SSE 'idAnalisis' de funcionAnalisis2). */
    public idAnalisis = new BehaviorSubject<number>(0);
    /** Filas de "Análisis Periodos" ya enriquecidas con volatilidad (vHistorico/vRelativa/desviacionStandard), publicadas por AnalisisPeriodosComponent para que otros componentes (ej. GraficaModeloComponent) no dupliquen ese cálculo. */
    public periodosEnriquecidos = new BehaviorSubject<any[]>([]);
    /** Petición para llevar la "Gráfica Análisis" con zoom a un período concreto de "Análisis Periodos" (fechas en ms). */
    public periodoEnfocar = new Subject<{ inicioMs: number; finMs: number }>();

    valformdata$ = this.formdata.asObservable();
    valRastHistoricoVolatividad = this.historicoVolatividad.asObservable();
    valCompaniasRastreador$ =this.companiasRastreador.asObservable();
    valcompaniaVolatividad$ = this.companiaVolatividad.asObservable();
    valIdNectumSeries$ = this.idNectumSeries.asObservable();
    valCompaniaSelec$ = this.companiaSeleccionada.asObservable();
    valLoadVolatil$ = this.loadVolatil.asObservable();
    valloadCompania$ = this.loadCompania.asObservable();
    valloadVolatilCompania$ = this.loadVolatilCompania.asObservable();
    valcompaniaAnalisis$ = this.companiaAnalisis.asObservable();
    vallistaVariacion$ = this.listaVariacion.asObservable();
    vallistaResultados$ = this.listaResultados.asObservable();
    vallistaVariacionNegativa$ = this.listaVariacionNegativa.asObservable();
    valDataEarning$ = this.dataEarning.asObservable();
    valIdAnalisis$ = this.idAnalisis.asObservable();
    valPeriodosEnriquecidos$ = this.periodosEnriquecidos.asObservable();
    valPeriodoEnfocar$ = this.periodoEnfocar.asObservable();
    idMercado$ = this.idMercado.asObservable();
    updateloadVolatilCompania(data: boolean){
        this.loadVolatilCompania.next(data);
    }

    updateDataearning(data: any){
        this.dataEarning.next(data);
    }

    updateIdAnalisis(id: number){
        this.idAnalisis.next(id);
    }

    updatePeriodosEnriquecidos(data: any[]){
        this.periodosEnriquecidos.next(data);
    }

    enfocarPeriodo(inicioMs: number, finMs: number){
        this.periodoEnfocar.next({ inicioMs, finMs });
    }

    /** Relee una corrida de análisis persistida (tbl_analisis + tablas hijas) por su id, para restaurarla vía /models?id=&modo=analisis. */
    obtenerAnalisisGuardado(idAnalisis: number): Observable<any> {
        return this._sseService.apiGetNew('rastreador/obtenerAnalisisGuardado?idAnalisis=' + idAnalisis);
    }

    updateloadCompania(data: boolean){
        this.loadCompania.next(data);
    }

    updatelistaVariacionNegativa(compania: any){
        this.listaVariacionNegativa.next(compania);
    }

    updatelistaVariacion(compania: any){
        this.listaVariacion.next(compania);
    }

    updateArrayResultados(data: any) {
      this.listaResultados.next(data);
    }

    updateIsVolati(data: boolean){
        this.loadVolatil.next(data);
    }

    updatecompaniaVolatividad(compania: any){
        this.companiaVolatividad.next(compania);
    }

    updatecompaniaAnalisis(compania: any){
        this.companiaAnalisis.next(compania);
    }

    updateCompaniaSelec (data: any){
        this.companiaSeleccionada.next(data);
    }
    updateIdNectumSeries (data: any){
        this.idNectumSeries.next(data);
    }

    updateCompaniaRastreador (compania: any){
        this.companiasRastreador.next(compania);
    }

    updateHistoricoVol (historico: any){
        this.historicoVolatividad.next(historico);
    }

    updateFormdata(newform: InterfaceformdataRastreador){
          console.log('Actualizando formdata:', newform); // Verifica que los datos sean correctos
        this.formdata.next(newform);
    }
    updateIdMercado(newIdMercado: number) {
        console.log('Actualizando idMercado:', newIdMercado); // Verifica que el nuevo idMercado sea correcto
        this.idMercado.next(newIdMercado);
    }
    
}